export const SUBSCRIBE = 'SUBSCRIBE'
export const SUBSCRIBE_SUCCEEDED = 'SUBSCRIBE_SUCCEEDED'
export const SUBMIT_CONTACT = 'SUBMIT_CONTACT'
export const POST_PROMO = 'POST_PROMO'
export const GET_QUOTE = 'GET_QUOTE'
